// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"8ec9d467","304":"99f8f55c","320":"fde7f091","419":"64dfd0d4","537":"4301f4f9","554":"987fc882","602":"9cbc6ec0","726":"b21026ae","755":"de8e5deb","774":"0dd6b4bd","857":"3244d42b","858":"7690aaee","883":"3bac5f82","895":"0e37e7d6"}[chunkId] + ".chunk.js";
};